import React, { useEffect, useState } from "react";
import { getUserById } from "../api/api";
import { environment } from "../../environments/environments";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaLock } from "react-icons/fa";
import "../CounsellorAllPages/CounsellorEditProfile.css";

const CounsellorEditProfile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;

        if (_id) {
          const res = await getUserById({ user_id: _id });
          setUserData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    getUserdata();
  }, []);

  const roleLabels = {
    connection_curator: "Connection Curator",
    match_making_consultant: "Match Making Consultant",
    relationship_success_coach: "Relationship Success Coach",
    match_success_advisor: "Match Success Advisor",
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  if (!userData) {
    return <div className="loader">No data found.</div>;
  }

  const {
    name,
    email,
    phone,
    dob,
    bio,
    address,
    postcode,
    image,
    available,
    role,
  } = userData;

  return (
    <div className="container">
      <div className="profile-scroll-wrapper">
        <div className="image-container">
          {image ? (
            <img
              src={`${environment.url}/uploads/counsellors/${image}`}
              alt="Profile"
              className="profile-image2"
            />
          ) : (
            <div className="placeholder-image">No Image</div>
          )}
          <button
            className="edit-icon-counsellorProfile"
            onClick={() => navigate("/CounsellorSidebar/CounsellorImageUpdate")}
          >
            <FaEdit />
          </button>
        </div>

        <div className="editprofilecard">
          <div className="card-header">
            <h3 className="h3">Profile Information</h3>
            <button
              className="counsellor-edit-button"
              onClick={() =>
                navigate("/CounsellorSidebar/CounsellorProfileEdit")
              }
            >
              <FaEdit />
            </button>
          </div>
          <div className="info-row">
            <span>Name:</span>
            <span>{name}</span>
          </div>
          <div className="info-row">
            <span>Email:</span>
            <span>{email}</span>
          </div>
          <div className="info-row">
            <span>Phone:</span>
            <span>{phone}</span>
          </div>
          <div className="info-row">
            <span>DOB:</span>
            <span>{dob}</span>
          </div>
          <div className="info-row">
            <span>Address:</span>
            <span>
              {address}, {postcode}
            </span>
          </div>
          <div className="info-row">
            <span>Bio:</span>
            <span>{bio}</span>
          </div>
          <div className="info-row">
            <span>Role:</span>
            <span>{roleLabels[role] || role}</span>
          </div>
        </div>

        <div className="editprofilecard">
          <div className="card-header">
            <h3 className="h3">Availability</h3>
            <button
              className="counsellor-edit-button"
              onClick={() => navigate("/CounsellorSidebar/Availabilityupdate")}
            >
              <FaEdit />
            </button>
          </div>
          {available?.map((day, index) => (
            <div key={index} className="info-row">
              <span>{day.day}</span>
              <span
                style={{ color: day.off_day === "1" ? "#d9534f" : "#5cb85c" }}
              >
                {day.off_day === "1" ? "Off" : `${day.start} - ${day.till}`}
              </span>
            </div>
          ))}
        </div>

        <div className="editprofilecardreset">
          <button
            className="reset-button"
            onClick={() =>
              //   navigate("/CounsellorSidebar/Resetpassword", { state: { email } })
              navigate("/CounsellorSidebar/CounsellorResetPassword", {
                state: { email },
              })
            }
          >
            <span>Reset Password</span>

            <FaLock />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounsellorEditProfile;
